// Class with friendly descriptions for UR Scan+Match Enumerations.
//
// DEVELOPER NOTE:  These properties are for demonstration purposes only to help developers in getting familiar with the UR Scan+Match Status Enumeration Values.
// In Your Application's Code, you should design your own methods and appropriate feedback to end users.
// This class is not intended for production code.

import { FaceTecURScanMatchInitializationError, FaceTecURScanMatchSessionStatus } from "../../../core-sdk/FaceTecURScanMatchSDK.js/FaceTecURScanMatchPublicAPI";
import { FaceTecURScanMatchSDK } from "../../../core-sdk/FaceTecURScanMatchSDK.js/FaceTecURScanMatchSDK";

export class URScanMatchStatusEnumFriendlyText {
  public static descriptionForInitializationError(enumValue: FaceTecURScanMatchInitializationError): string {
    switch (enumValue) {
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.DeviceNotSupported:
        return "The device is incompatible with the UR Scan+Match SDK.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.NetworkIssues:
        return "Initialize failed due to network issues.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.InvalidLicense:
        return "The license provided was invalid.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.ResourcesCouldNotBeLoadedOnLastInit:
        return "The UR Scan+Match SDK could not load resources.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.GetUserMediaRemoteHTTPNotSupported:
        return "The Camera APIs are only supported on localhost or https.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchInitializationError.UnknownInternalError:
        return "An unknown and unexpected error occurred.";
      default:
        return "Unexpected FaceTecURScanMatchInitializationError Value: " + enumValue;
    }
  }

  public static descriptionForSessionStatus(enumValue: FaceTecURScanMatchSessionStatus): string {
    switch (enumValue) {
      case FaceTecURScanMatchSDK.FaceTecURScanMatchSessionStatus.SessionCompleted:
        return "The Session was performed successfully.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchSessionStatus.CameraPermissionsDenied:
        return "The user did not enable the camera after prompting for camera permissions or camera permissions were previously denied.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchSessionStatus.CameraInitializationIssue:
        return "The Session was cancelled because the SDK was unable to start the Camera on this Device";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchSessionStatus.IFrameNotAllowedWithoutPermission:
        return "The Session was cancelled because you do not have permission to run the UR Scan+Match SDK in an iFrame. Please contact FaceTec to request permission.";
      case FaceTecURScanMatchSDK.FaceTecURScanMatchSessionStatus.UnknownInternalError:
        return "The Session was cancelled because of an Unknown Error.";
      default:
        return "Unexpected FaceTecURScanMatchSessionStatus Value: " + enumValue;
    }
  }
}
